module.exports = __webpack_public_path__ + "img/6.d43edf68.jpg";